document.addEventListener('DOMContentLoaded', function() {
    const acordeones = document.querySelectorAll('.collapsible-content .grid__item .accordion details');
    const abrirAcordeon = (acordeon) => {
        acordeon.setAttribute('open', '');
    };
    const cerrarAcordeon = (acordeon) => {
        acordeon.removeAttribute('open');
    };
    acordeones.forEach(abrirAcordeon);
    setTimeout(() => {
        acordeones.forEach(cerrarAcordeon);
    }, 10000);
});